import React from "react";

export default React.createContext({
    crumbs: [
        {
			title : "",
			page : "",
            color :"",
            icon :""
        }
    ],
    setCrumbs: value => {}
});
